/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Blog_EmptyInputs */

const cs_public_site_blog_empty = /** @type {(inputs: Public_Site_Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné články.`)
};

const en_public_site_blog_empty = /** @type {(inputs: Public_Site_Blog_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No articles yet.`)
};

/**
* | output |
* | --- |
* | "No articles yet." |
*
* @param {Public_Site_Blog_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_blog_empty = /** @type {((inputs?: Public_Site_Blog_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Blog_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_blog_empty(inputs)
	return cs_public_site_blog_empty(inputs)
});